module.exports = __webpack_public_path__ + "static/media/cookie-icon.5bd586c5.svg";